const translations = {
  common: {
    accountSettings: 'Account settings',
    alreadyHaveAnAccount: 'Already have an account?',
    changePasswordSuccess: 'Your password has been changed successfully',
    confirm: 'Submit',
    confirmPassword: 'Confirm password',
    createAccount: 'Create one here',
    currentPassword: 'Current Password',
    dontHaveAccountQuestion: 'Don’t have an account?',
    email: 'Email',
    errorBoundaryMessage: 'An error occurred',
    errorMessage: 'There was an error',
    firstName: 'First Name',
    forgotPassword: 'Forgot password?',
    forgotPasswordChange: 'Step 3: Enter your new password',
    forgotPasswordEmailResend: 'Didn’t get a code?',
    forgotPasswordEmailSent:
      'Step 2: Enter the verification code we just sent to your email address',
    forgotPasswordLegend:
      'Step 1: Enter your email and we’ll help you reset your password',
    goBackHome: 'Go back home',
    invalidEmail: 'Invalid email',
    lastName: 'Last Name',
    lengthToken: 'Must have six digits',
    locale: 'Language',
    newPassword: 'New Password',
    next: 'Next',
    pageNotFoundLegend:
      "It seems like the page you are looking for doesn't exist",
    pageNotFoundTitle: '404',
    password: 'Password',
    passwordsDontMatch: 'The passwords don’t match',
    reportError: 'Report error',
    required: 'Required',
    resetPassword: 'Reset Password',
    resetPasswordSuccess: 'Your password has been updated succesfully',
    selectLanguage: 'Select language',
    selectOption: 'Select an option',
    shortPassword: 'Password too short, minimum length is 8 characters',
    signIn: 'Sign in',
    signOut: 'Sign out',
    signUp: 'Sign up',
    token: 'Code',
    updatePassword: 'Update Password',
    updateSettings: 'Update Settings',
    updateSettingsSuccess: 'Your settings have been updated successfully',
  },
};

export default translations;
